import { render, staticRenderFns } from "./PortalContentV1.vue?vue&type=template&id=039155a4&"
import script from "./PortalContentV1.vue?vue&type=script&lang=js&"
export * from "./PortalContentV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports